import { render, staticRenderFns } from "./SchoolRegistration.vue?vue&type=template&id=089abdc4&scoped=true"
import script from "./SchoolRegistration.vue?vue&type=script&lang=js"
export * from "./SchoolRegistration.vue?vue&type=script&lang=js"
import style0 from "./SchoolRegistration.vue?vue&type=style&index=0&id=089abdc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089abdc4",
  null
  
)

export default component.exports